import type { ITwoStrandedChainItem } from 'domain/entities/monomer-chains/ChainsCollection';
import { STRAND_TYPE } from 'domain/constants';
import type { BaseMonomer } from 'domain/entities/BaseMonomer';
import { PolymerBond } from 'domain/entities/PolymerBond';
import type { SubChainNode } from 'domain/entities/monomer-chains/types';

export const getNodeFromTwoStrandedNode = (
  twoStrandedNode: ITwoStrandedChainItem,
  strandType: STRAND_TYPE,
) => {
  return strandType === STRAND_TYPE.SENSE
    ? twoStrandedNode.senseNode
    : twoStrandedNode.antisenseNode;
};

export const getNextConnectedNode = (
  node: SubChainNode,
  monomerToNode: Map<BaseMonomer, SubChainNode>,
) => {
  const r2PolymerBondBetweenNodes =
    node.lastMonomerInNode.attachmentPointsToBonds.R2;
  const anotherMonomerConnectedToAntisenseNode =
    r2PolymerBondBetweenNodes instanceof PolymerBond &&
    r2PolymerBondBetweenNodes?.getAnotherMonomer(node.lastMonomerInNode);
  const nextConnectedNode =
    (anotherMonomerConnectedToAntisenseNode &&
      monomerToNode.get(anotherMonomerConnectedToAntisenseNode)) ||
    undefined;

  return nextConnectedNode;
};

export const getPreviousConnectedNode = (
  node: SubChainNode,
  monomerToNode: Map<BaseMonomer, SubChainNode>,
) => {
  const r1PolymerBondBetweenNodes =
    node.firstMonomerInNode.attachmentPointsToBonds.R1;
  const anotherMonomerConnectedToAntisenseNode =
    r1PolymerBondBetweenNodes instanceof PolymerBond &&
    r1PolymerBondBetweenNodes?.getAnotherMonomer(node.firstMonomerInNode);
  const previousConnectedNode =
    (anotherMonomerConnectedToAntisenseNode &&
      monomerToNode.get(anotherMonomerConnectedToAntisenseNode)) ||
    undefined;

  return previousConnectedNode;
};
